import { API } from 'aws-amplify';

export default function updateDocument(document) {
    const mutation = `mutation updateDocument (
        $mpID: String!
        $title: String
        $documentType: String
        $language: String
      ) {
      updateDocument(
        mpID: $mpID
        title: $title
        documentType: $documentType
        language: $language
      ) {
        mpID
      }
    }`

    return API.graphql({
      query: mutation,
      variables: {
        ...document,
      },
    })
}
